


























import Vue from "vue";
import mixins from 'vue-typed-mixins';
import scroll from 'scroll';
import scrollDoc from 'scroll-doc';
import debounce from 'debounce';

import PageListNavigator,{ PageListNavigatorComputed } from '../mixins/PageListNavigator';
import IsSmall from '../mixins/IsSmall';
import { IPage, IState } from "../store/state";
import PageItem from "./PageItem.vue";

const page = scrollDoc();

// Only scroll when spam is done.
const scrollBounced = debounce(($el: Element, isSmall: boolean) => {
	const y = $el.getBoundingClientRect().top + window.scrollY - (isSmall ? 85 : 65);
	scroll.top(page, y, { duration: 250 });
}, 10)

interface PageListComputed extends PageListNavigatorComputed {
  minimenu: boolean;
  classes: any;
}

interface PageListData {
}

interface PageListMethods {
}

export default mixins(PageListNavigator, IsSmall).extend<PageListData, PageListMethods, PageListComputed, {}>({
  name: "PageList",
  computed: {
    minimenu() {
      return this.$store.state.config.minimenu && !this.isSmall;
    },
    classes() {
      return {
        "kb-ia-list": true,
        "kb-ia-list--minimenu": this.minimenu
      };
	},
	pages() {
		if(this.minimenu) {
			return (this.$store.state as IState).pages.filter(page => page.open);
		}
		return this.$store.state.pages;
	}
  },
  watch: {
	//   pages(p){
	// 	  if(this.minimenu) {
	// 		  scrollBounced(this.$el, this.isSmall)
	// 	  }
	//   }
  },
  components: {
    PageItem
  }
});
